const features = [
  'Product discovery',
  'Spreadsheet resources',
  'QC process',
  'Warehouse',
  'Shipping',
  'Payment',
  'Beginner friendly',
  'Support',
  'Research experience',
];

const agents = [
  { name: 'AllChinaBuy', color: 'bg-primary-500' },
  { name: 'Superbuy', color: 'bg-secondary-500' },
  { name: 'CSSBuy', color: 'bg-secondary-500' },
  { name: 'Sugargoo', color: 'bg-secondary-500' },
];

export default function ComparisonTable() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">Comparison</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950">
            Compare Before You Buy
          </h2>
        </div>

        <div className="max-w-5xl mx-auto overflow-x-auto">
          <table className="w-full min-w-[700px] border-collapse">
            <thead>
              <tr>
                <th className="text-left px-4 py-3 text-sm font-semibold text-foreground-600 border-b border-background-200">
                  Feature
                </th>
                {agents.map((agent) => (
                  <th key={agent.name} className="px-4 py-3 text-sm font-semibold text-foreground-600 border-b border-background-200 text-center">
                    {agent.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {features.map((feat, idx) => (
                <tr key={feat} className={idx % 2 === 0 ? 'bg-background-50' : 'bg-white'}>
                  <td className="px-4 py-3 text-sm font-medium text-foreground-800 border-b border-background-100">
                    {feat}
                  </td>
                  {agents.map((agent, aIdx) => (
                    <td key={`${agent.name}-${feat}`} className="px-4 py-3 text-center border-b border-background-100">
                      <span className={`inline-block w-3 h-3 rounded-full ${aIdx === 0 ? 'bg-primary-500' : 'bg-secondary-400'}`} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-center mt-6 text-xs text-foreground-500">
          Independent comparison for informational purposes only. Results may vary based on individual experience.
        </p>
      </div>
    </section>
  );
}